import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserTokenResponse } from '@shared-interfaces/base-core-services.interface';
import { HttpErrorHandlerService, MessageType } from '@shared-services/http-error-handling.service';
import { LoginRequest } from '../../interfaces/login.interface';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-inventory-ui',
  templateUrl: './inventory-ui.component.html',
  styleUrls: ['./inventory-ui.component.less']
})
export class InventoryUiComponent implements OnInit {
  public validateForm: FormGroup;
  public passwordVisible = false;
  public password: string;
  public customRoles = [];
  public loading = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private httpMessage: HttpErrorHandlerService,
    private translate: TranslateService
  ) {}
  signup(): void {
    this.router.navigateByUrl('/signup');
  }
  forgotpassword(): void {
    this.router.navigateByUrl('/forgot-password');
  }
  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  }
  goto(): void {
    // this.router.navigateByUrl("/app");
    this.loading = true;
    if (this.validateForm.valid) {
      const loginBody: LoginRequest = {
        username: this.validateForm.value.userName,
        password: this.validateForm.value.password,
      };
      this.loginService.login(loginBody).subscribe(
        (res: UserTokenResponse) => {
          if (res.userType === 'admin_user') {
            this.loginService.setUserData(
              res,
              this.validateForm.value.userName
            );
            this.router.navigateByUrl('/app/landing');
            this.loading = false;
          } else {
            this.httpMessage.showTopFloatMessage(
              this.translate.instant('app.label.only-admin-allowed'),
              MessageType.ERROR,
              this.translate.instant('app.label.unauthorised')
            );
            this.loading = false;
          }
        },
        (error: any) => {
          this.httpMessage.showTopFloatMessage(
            error.error,
            MessageType.ERROR,
            this.translate.instant('app.signin.failed.title')
          );
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
    }
  }
  ngOnInit(): void {
    this.validateForm = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remember: [true],
    });
  }
}
